import * as React from "react";

export function PrincipleSavesTimeIllustration(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 800 450" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
      <defs>
        <marker id="dsosArrow" markerWidth="10" markerHeight="10" refX="9" refY="5" orient="auto">
          <path d="M0 0L10 5L0 10Z" fill="hsl(var(--primary))" />
        </marker>
      </defs>

      <rect
        x="40"
        y="40"
        width="720"
        height="370"
        rx="24"
        fill="hsl(var(--card))"
        stroke="hsl(var(--border))"
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
      />

      {/* Options node */}
      <rect
        x="320"
        y="70"
        width="160"
        height="56"
        rx="18"
        fill="hsl(var(--card))"
        stroke="hsl(var(--border))"
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
      />
      <text x="400" y="104" fontSize="14" fontWeight="800" textAnchor="middle" fill="hsl(var(--foreground))">
        Options
      </text>

      {/* Disabled branches (dashed + X) */}
      {[
        { x: 170, y: 205 },
        { x: 300, y: 205 },
        { x: 500, y: 205 },
        { x: 630, y: 205 },
      ].map((p, i) => (
        <g key={i}>
          <path
            d={`M400 126 C 400 150, ${p.x} 150, ${p.x} 182`}
            stroke="hsl(var(--border))"
            strokeWidth="1.5"
            strokeDasharray="6 6"
            vectorEffect="non-scaling-stroke"
          />
          <rect
            x={p.x - 60}
            y={p.y - 28}
            width="120"
            height="56"
            rx="18"
            fill="hsl(var(--card))"
            stroke="hsl(var(--border))"
            strokeWidth="1.5"
            vectorEffect="non-scaling-stroke"
          />
          <text x={p.x} y={p.y + 5} fontSize="12" fontWeight="700" textAnchor="middle" fill="hsl(var(--muted-foreground))">
            Option
          </text>
          {/* X */}
          <path
            d={`M${p.x - 18} ${p.y - 14} L${p.x + 18} ${p.y + 14}`}
            stroke="hsl(var(--muted-foreground))"
            strokeWidth="1.5"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d={`M${p.x + 18} ${p.y - 14} L${p.x - 18} ${p.y + 14}`}
            stroke="hsl(var(--muted-foreground))"
            strokeWidth="1.5"
            vectorEffect="non-scaling-stroke"
          />
        </g>
      ))}

      {/* The one chosen path (primary) */}
      <path
        d="M400 126 C 400 170, 400 210, 400 255"
        stroke="hsl(var(--primary))"
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
        markerEnd="url(#dsosArrow)"
      />

      {/* Next action */}
      <rect
        x="270"
        y="290"
        width="260"
        height="110"
        rx="22"
        fill="hsl(var(--card))"
        stroke="hsl(var(--primary))"
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
      />
      <text x="400" y="330" fontSize="14" fontWeight="900" textAnchor="middle" fill="hsl(var(--foreground))">
        Next action
      </text>
      <text x="400" y="356" fontSize="12" fontWeight="700" textAnchor="middle" fill="hsl(var(--muted-foreground))">
        One path. No choices.
      </text>
      <rect
        x="310"
        y="368"
        width="180"
        height="18"
        rx="9"
        fill="hsl(var(--primary) / 0.12)"
        stroke="hsl(var(--primary))"
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}
